module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "line-height": "normal",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "editor"
  }), _vm._v(" "), _c('input', {
    ref: "uploadImg",
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "file",
      "accept": "image/png, image/jpeg, image/gif, image/jpg",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.uploadImg
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28ecd4e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/QuillEditor.vue
// module id = 897
// module chunks = 0